<template>
    <detail-layout-full-width>
        <template slot="header">
            <BaseHeader :content="header" />
        </template>
        <template slot="main">
           <div class="mb-8">
            <el-switch 
              class="switch-text break-normal both-switch" 
              v-model="isReportVerifactu"
              :active-text="$t('verifactu.header')"
              :inactive-text="$t('tipos.modulo_name.tbai')"
              inactive-color="var(--primary-800)"
            />
          </div>
          <div v-if="isReportVerifactu" class="form-wrapper">
              <el-form :model="form" :rules="rules" ref="ruleForm">
                <div class="lg:max-w-detail lg:mr-auto">
                  <div class="flex flex-row items-center gap-4 lg:mb-4">
                    <div class="flex flex-col md:flex-row mb-2">
                      <el-switch 
                      class="break-normal both-switch min-h-12" 
                      v-model="form.activado" 
                      :active-text="$t('app.active')" 
                      />
                    </div>
                    <div v-if="form.activado" class="lg:mb-2" >
                      <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('invoices.fecha_alta') }}</label>
                      <el-form-item class="mb-0" prop="fechaActivacion">
                        <el-date-picker class="bg-white dark:bg-darkblue-900" :disabled="role === 4"
                        v-model="form.fechaActivacion" type="date" :picker-options="dateRangeOptions"
                        :format="datePattern" value-format="yyyy-MM-dd[T]HH:mm:ss" placeholder="">
                      </el-date-picker>
                    </el-form-item>
                  </div>
                  </div>
                  <div class="lg:mb-2">
                      <div class="mandatory">
                          <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isVerifactuActive"/>{{ $t('companies.configuration_tbai.tbaiconfig_regimen') }}</label>
                          <el-form-item prop="tipoRegimen">
                              <el-select class="w-full z-10" 
                                v-model="form.tipoRegimen" :options="tiposRegimen" 
                                :disabled="isRoleUserOrConsulta" 
                                clearable 
                                filtrable>
                                <el-option
                                  v-for="opt in tiposRegimen"
                                  :key="opt.id"
                                  :label="opt.name"
                                  :value="opt.id">
                                  <el-popover v-if="showPopover(opt.id)"
                                    placement="top-start"
                                    :open-delay="600"
                                    trigger="hover"
                                    :content="opt.long"
                                    width="500"
                                    popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200 text-justify"
                                  >
                                    <span slot="reference" class="option-text">{{ opt.name }}</span>
                                  </el-popover>
                                </el-option>
                              </el-select>
                          </el-form-item>
                      </div>
                  </div>
                  <div class="lg:mb-2">
                      <div class="mandatory">
                          <label
                              class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isVerifactuActive"/>{{ $t('verifactu.invoice_type.entity_name') }}</label>
                          <el-form-item prop="tipoFactura">
                              <base-el-select class="w-full" v-model="form.tipoFactura" :options="tiposFacturas" :disabled="isRoleUserOrConsulta" clearable filtrable />
                          </el-form-item>
                      </div>
                  </div>
                  <div class="lg:mb-2">
                      <div class="mandatory">
                          <label
                              class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isVerifactuActive"/>{{ $t('verifactu.verifactu_rectificativa_type.entity_name') }}</label>
                          <el-form-item prop="tipoFacturaRectificativa">
                              <base-el-select class="w-full" v-model="form.tipoFacturaRectificativa" :options="tiposFacturasRectificativas" :disabled="isRoleUserOrConsulta" clearable filtrable />
                          </el-form-item>
                      </div>
                  </div>
                  <div class="lg:mb-2">
                      <div class="mandatory">
                          <label
                              class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isVerifactuActive"/>{{ $t('verifactu.verifactu_exenta_type.entity_name') }}</label>
                          <el-form-item prop="tipoExenta">
                              <base-el-select class="w-full" v-model="form.tipoExenta" :options="tiposExenta" :disabled="isRoleUserOrConsulta" clearable filtrable />
                          </el-form-item>
                      </div>
                  </div>
                  <div class="lg:mb-2">
                      <div class="mandatory">
                          <label
                              class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isVerifactuActive"/>{{ $t('companies.configuration_tbai.tbaiconfig_no_exenta') }}</label>
                          <el-form-item prop="tipoNoExenta">
                              <base-el-select class="w-full" v-model="form.tipoNoExenta" :options="tiposNoExenta" :disabled="isRoleUserOrConsulta" clearable filtrable />
                          </el-form-item>
                      </div>
                  </div>
                  <div class="lg:mb-2">
                      <div class="mandatory">
                          <label
                              class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isVerifactuActive"/>{{ $t('companies.configuration_tbai.tbaiconfig_no_sujeta') }}</label>
                          <el-form-item prop="tipoNoSujeta">
                              <base-el-select class="w-full" v-model="form.tipoNoSujeta" :options="tiposNoSujeta" :disabled="isRoleUserOrConsulta" clearable filtrable />
                          </el-form-item>
                      </div>
                  </div>
                </div>
              </el-form>
          </div>

          <div v-else class="form-wrapper">
            <el-form :model="formTbai" :rules="rulesTbai" ref="ruleFormTbai">
              <div class="lg:max-w-detail lg:mr-auto">
                <div class="flex flex-row items-center gap-4 lg:mb-4">
                  <div class="flex flex-col md:flex-row mb-2">
                    <el-switch 
                      class="switch-text break-normal both-switch min-h-12" 
                      v-model="formTbai.ActivadoTBAI" 
                      :active-text="$t('app.active')"
                    />
                  </div>
                  <div v-if="formTbai.ActivadoTBAI" class="lg:mb-2">
                    <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isTbaiActive"/>{{ $t('invoices.fecha_alta') }}</label>
                    <el-form-item class="mb-0" prop="fechaActivacion">
                      <el-date-picker class="bg-white dark:bg-darkblue-900" :disabled="role === 4"
                        v-model="formTbai.fechaActivacion" type="date" :picker-options="dateRangeOptions"
                        :format="datePattern" value-format="yyyy-MM-dd[T]HH:mm:ss" placeholder="">
                      </el-date-picker>
                    </el-form-item>
                  </div> 
                </div>
                <div class="mb-4">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.configuration_tbai.criteriocobrosypagos')}}</label>
                    <div class="flex flex-col md:flex-row">
                      <el-switch 
                        class="switch-text break-normal both-switch" 
                        v-model="formTbai.CriterioCobrosYPagos" 
                        :disabled="isRoleUserOrConsulta"
                        :active-text="$t('app.active')" 
                        />
                    </div>
                </div>
                <div class="lg:mb-2">
                    <div class="mandatory">
                        <label
                            class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isTbaiActive"/>{{ $t('companies.configuration_tbai.tbaiconfig_regimen') }}</label>
                        <el-form-item prop="tipoRegimen">
                            <base-el-select class="w-full" v-model="formTbai.tipoRegimen" :options="tiposRegimenTbai" :disabled="isRoleUserOrConsulta" clearable filtrable />
                        </el-form-item>
                    </div>
                </div>
                <div class="lg:mb-2">
                    <div class="mandatory">
                        <label
                            class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isTbaiActive"/>{{ $t('companies.configuration_tbai.tbaiconfig_operacion') }}</label>
                        <el-form-item prop="tipoOperacion">
                            <base-el-select class="w-full" v-model="formTbai.tipoOperacion" :options="tiposOperacion" :disabled="isRoleUserOrConsulta" clearable filtrable />
                        </el-form-item>
                    </div>
                </div>
                <div class="lg:mb-2">
                    <div class="mandatory">
                        <label
                            class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isTbaiActive"/>{{ $t('companies.configuration_tbai.tbaiconfig_no_exenta') }}</label>
                        <el-form-item prop="tipoNoExenta">
                            <base-el-select class="w-full" v-model="formTbai.tipoNoExenta" :options="tiposNoExentaTbai" :disabled="isRoleUserOrConsulta" clearable filtrable />
                        </el-form-item>
                    </div>
                </div>
                <div class="lg:mb-2">
                    <div class="mandatory">
                        <label
                            class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isTbaiActive"/>{{ $t('companies.configuration_tbai.tbaiconfig_no_sujeta') }}</label>
                        <el-form-item prop="tipoNoSujeta">
                            <base-el-select class="w-full" v-model="formTbai.tipoNoSujeta" :options="tiposNoSujetaTbai" :disabled="isRoleUserOrConsulta" clearable filtrable />
                        </el-form-item>
                    </div>
                </div>
                <div class="lg:mb-2">
                    <div class="mandatory">
                        <label
                            class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isTbaiActive"/>{{ $t('companies.configuration_tbai.hacienda') }}</label>
                        <el-form-item prop="tipoHacienda">
                            <base-el-select class="w-full" v-model="formTbai.tipoHacienda" :options="tiposHacienda" :disabled=" !isCompanyCreation && !newAlta" clearable filtrable />
                        </el-form-item>
                    </div>
                </div>
                <div class="lg:mb-2">
                    <div class="mandatory">
                        <label
                            class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration_tbai.epigrafe') }}</label>
                        <el-form-item prop="epigrafe">
                            <el-input class="w-full" v-model="formTbai.epigrafe" :disabled="isRoleUserOrConsulta" clearable />
                        </el-form-item>
                    </div>
                </div>
              </div>
            </el-form>
          </div>

        </template>
        <template slot="layout-extend">
          <base-footer>
            <template slot="actions">
              <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
                :loading="isGeneralLoading" />
              <base-button-responsive 
                mode="primary" 
                :text="isCompanyCreation ? $t('app.save_and_continue') : $t('app.save')" 
                icon="check" @click="submitHandler()"
                :loading="isGeneralLoading" 
                :disabled="isGeneralLoading" />
            </template>
          </base-footer>
        </template>
    </detail-layout-full-width>
</template>
<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import { getModulosCliente } from '@/services/companies/getModulosCliente'
import { getCompany } from '@/services/companies/getCompany'
import { getConfiguracionVerifactu } from '@/services/configurations/getConfiguracionVerifactu'
import { updateConfiguracionVerifactu } from '@/services/configurations/updateConfiguracionVerifactu'
import { addConfiguracionVerifactu } from '@/services/configurations/addConfiguracionVerifactu'
import { getConfiguracionTBAI } from '@/services/configurations/getConfiguracionTBAI'
import { actualizarConfiguracionTBAI } from '@/services/configurations/actualizarConfiguracionTBAI'
import { agregarConfiguracionTBAI } from '@/services/configurations/agregarConfiguracionTBAI'
import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'
import moment from 'moment'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

import { i18n } from '@/i18n'

export default {
  name: 'report-config',
  components: {
    DetailLayoutFullWidth
  },
  data () {
    return {
      header: {
        title: i18n.t('companies.hacienda_report'),
        icon: 'companies',
        breadcrumb: {},
        url: 'companies/detail'
      },
      dateRangeOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.disabledDate
      },
      idCliente: null,
      isReportVerifactu: true,
      form: {
        idCIFEmpresa: '',
        tipoRegimen: '',
        tipoFactura: '',
        tipoFacturaRectificativa: '',
        tipoExenta: '',
        tipoNoExenta: '',
        tipoNoSujeta: '',
        activado: false,
        fechaActivacion: ''
      },
      formTbai: {
        idCIFEmpresa: '',
        tipoRegimen: '',
        tipoOperacion: '',
        tipoNoExenta: '',
        tipoNoSujeta: '',
        tipoHacienda: '',
        CriterioCobrosYPagos: false,
        epigrafe: '',
        ActivadoTBAI: false,
        fechaActivacion: ''
      },
      rules: {
        tipoRegimen: [
          {
            required: this.isVerifactuActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoFactura: [
          {
            required: this.isVerifactuActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoFacturaRectificativa: [
          {
            required: this.isVerifactuActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoExenta: [
          {
            required: this.isVerifactuActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoNoExenta: [
          {
            required: this.isVerifactuActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        
        tipoNoSujeta: [
          {
            required: this.isVerifactuActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        fechaActivacion: [
          {
            required: this.isVerifactuActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur',
          }
        ],
      },
      rulesTbai: {
        tipoRegimen: [
          {
            required: this.isTbaiActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoOperacion: [
          {
            required: this.isTbaiActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoNoExenta: [
          {
            required: this.isTbaiActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoNoSujeta: [
          {
            required: this.isTbaiActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoHacienda: [
          {
            required: this.isTbaiActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        epigrafe: [
          {
            max: 7,
            message: this.$i18n.t('validation.length_max', { maxLength: 7 }),
            trigger: 'blur'
          },
        ],
        fechaActivacion: [
          {
            required: this.isTbaiActive,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur',
          }
        ],
      },
      newAlta: false
    }
  },
  async mounted () {
    this.form.idCIFEmpresa = this.id
    this.formTbai.idCIFEmpresa = this.id

    // // this.isReportVerifactu = !!this.hasVerifactuModule
    
    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: this.$i18n.t('companies.header') })
    
    const company = await this.getCompanyData(this.id)
    this.idCliente = company?.IdCliente

    if (this.$store.getters['app/fromRouteName'] !== null) {
      const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
      breadcrumbs.push({ path: '', name: breadcrumbHeader })
    } else {
      breadcrumbs.push({ path: '', name: company.RazonSocial })
      this.$store.commit('app/setheaderBreadCrumb', company.RazonSocial)
    }
    this.header.breadcrumb = breadcrumbs

    if (!this.isCompanyCreation) {
      this.$store.commit('app/setModulesClient', [])
      try {
        const params = {
          idCliente: this.idCliente,
        }
        const payload = [
          8, // TBAI
          31, // Verifactu
        ]
        const response = await getModulosCliente(payload, params)
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.$store.commit('app/setModulesClient', response.Respueta)
        }
      } catch (error) {
        this.doFeedback()
      }
    
      if (this.getModulesClient.includes(31)) {
        this.isReportVerifactu = true
        var res = await getConfiguracionVerifactu({ idCIFEmpresa: this.form.idCIFEmpresa })
        if (!res.blnError) {
          if (res.respuesta) {
            this.setConfig(res.respuesta)
          } else {
            this.newAlta = true
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
        }
      }

      if (this.getModulesClient.includes(8)) {
        this.isReportVerifactu = false
        var resTbai = await getConfiguracionTBAI({ idCIFEmpresa: this.formTbai.idCIFEmpresa })
        if (!resTbai.blnError) {
          if (resTbai.Respuesta) {
            this.setConfigTbai(resTbai.Respuesta)
          } else {
            this.newAlta = true
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', resTbai))
        }
      }
    }
  },
  watch: {
    'form.activado': function (value, oldValue) {
      if (value !== oldValue) {
        if (value) {
          this.form.fechaActivacion = this.form.fechaActivacion ? this.form.fechaActivacion : moment().format('yyyy-MM-DD[T00:00:00]')
        }
      }
    },
    'formTbai.ActivadoTBAI': function (value, oldValue) {
      if (value !== oldValue) {
        if (value) {
          this.formTbai.fechaActivacion = this.formTbai.fechaActivacion ? this.formTbai.fechaActivacion : moment().format('yyyy-MM-DD[T00:00:00]')
        }
      }
    }
  },
  computed: {
    id: function () {
      return parseInt(this.$route.params.id)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isVerifactuActive: function () {
      return this.form.activado
    },
    isTbaiActive: function () {
      return this.formTbai.ActivadoTBAI
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isCompanyCreation: function () {
      return !!this.$store.getters['app/isInMode'](3)
    },
    getModulesClient: function () {
      return this.$store.getters['app/getModulesClient']
    },
    hasVerifactuModule: function () {
      return this.getModulesClient.includes(31)
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    tiposRegimen: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_REGIMEN']
    },
    tiposFacturas: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_FACTURAS']
    },
    tiposFacturasRectificativas: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_FACTURAS_RECTIFICATIVAS']
    },
    tiposExenta: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_EXENTA']
    },
    tiposNoExenta: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_NO_EXENTA']
    },
    tiposNoSujeta: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_NO_SUJETA']
    },
    tiposRegimenTbai: function () {
      return this.$store.getters['config/TIPOS_TBAI_REGIMEN']
    },
    tiposOperacion: function () {
      return this.$store.getters['config/TIPOS_TBAI_OPERACION']
    },
    tiposNoExentaTbai: function () {
      return this.$store.getters['config/TIPOS_TBAI_NO_EXENTA']
    },
    tiposNoSujetaTbai: function () {
      return this.$store.getters['config/TIPOS_TBAI_NO_SUJETA']
    },
    tiposHacienda: function () {
      return this.$store.getters['config/TIPOS_HACIENDA']
    },
  },
  methods: {
    disabledDate: function (date) {
      const today = moment().startOf('day') // Día actual sin hora
      const dateMoment = moment(date)
      // Deshabilitar si la fecha es anterior a hoy
      return dateMoment.isBefore(today, 'day')
    },
    getCompanyData: async function (idCIFEmpresa) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: idCIFEmpresa }
        const company = await getCompany(params)
        if (!company.blnError) {
          return company.CIFEmpresa
        }
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', company))
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setConfig: function (data) {
      this.form.tipoRegimen = data?.claveRegimenEspecial || ''
      this.form.tipoFactura = data?.tipoFactura || ''
      this.form.tipoFacturaRectificativa = data?.tipoFacturaRectificativa || ''
      this.form.tipoExenta = data?.tipoExenta || ''
      this.form.tipoNoExenta = data?.tipoNoExenta || ''
      this.form.tipoNoSujeta = data?.tipoNoSujeta || ''
      this.form.activado = data?.activado
      this.form.fechaActivacion = data?.fechaActivacion
      this.newAlta = !data
    },
    setConfigTbai: function (data) {
      this.formTbai.CriterioCobrosYPagos = data?.CriterioCobrosYPagos || false
      this.formTbai.tipoRegimen = data?.ClaveRegimenEspecial || ''
      this.formTbai.tipoOperacion = data?.TipoOperacionDefecto || ''
      this.formTbai.tipoNoExenta = data?.TipoNoExentaDefecto || ''
      this.formTbai.tipoNoSujeta = data?.TipoNoSujetaDefecto || ''
      this.formTbai.tipoHacienda = data?.idHacienda.toString() || ''
      this.formTbai.epigrafe = data?.Epigrafe || ''
      this.formTbai.ActivadoTBAI = data?.ActivadoTBAI
      this.formTbai.fechaActivacion = data?.fechaActivacion
      this.newAlta = !data?.idHacienda
    },
    submitHandler: async function () {
      if (this.isReportVerifactu && this.isVerifactuActive) {
        await this.submitForm('ruleForm')
      } else if (this.isTbaiActive) {
        await this.submitFormTbai('ruleFormTbai')
      } else {
        if (this.isCompanyCreation) this.goNext()
      }
    },
    submitForm: async function (formName) {
      setTimeout(() => {
        this.$store.commit('setIsLoading', true)
        this.$refs[formName].validate(async valid => {
          if (valid) {
            const data = {
              idCIFEmpresa: this.form.idCIFEmpresa,
              CriterioCobrosYPagos: this.form.CriterioCobrosYPagos,
              claveRegimenEspecial: this.form.tipoRegimen,
              tipoFactura: this.form.tipoFactura,
              tipoFacturaRectificativa: this.form.tipoFacturaRectificativa,
              tipoExenta: this.form.tipoExenta,
              tipoNoExenta: this.form.tipoNoExenta,
              tipoNoSujeta: this.form.tipoNoSujeta,
              activado: this.form.activado,
              fechaActivacion: this.form.fechaActivacion
            }
            var response = null
            try {
              if (this.newAlta || this.isCompanyCreation) {
                this.newAlta = false
                response = await addConfiguracionVerifactu(data, { idCIFEmpresa: this.form.idCIFEmpresa })
                if (this.isCompanyCreation) this.goNext()
              } else {
                response = await updateConfiguracionVerifactu(data, { idCIFEmpresa: this.form.idCIFEmpresa })
              }
              if (response && response.blnError === false && response.Respuesta) {
                this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
              } else {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              }
            } catch (error) {
              this.doFeedback()
            } finally {
              this.$store.commit('setIsLoading', false)
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
            this.$store.commit('setIsLoading', false)
            return false
          }
        })
      }, 100)
    },
    submitFormTbai: async function (formName) {
      setTimeout(() => {
        this.$store.commit('setIsLoading', true)
        this.$refs[formName].validate(async valid => {
          if (valid) {
            const data = {
              idCIFEmpresa: this.formTbai.idCIFEmpresa,
              CriterioCobrosYPagos: this.formTbai.CriterioCobrosYPagos,
              ClaveRegimenEspecial: this.formTbai.tipoRegimen,
              TipoOperacionDefecto: this.formTbai.tipoOperacion,
              TipoNoExentaDefecto: this.formTbai.tipoNoExenta,
              TipoNoSujetaDefecto: this.formTbai.tipoNoSujeta,
              idHacienda: this.formTbai.tipoHacienda,
              Epigrafe: this.formTbai.epigrafe,
              ActivadoTBAI: this.formTbai.ActivadoTBAI,
              fechaActivacion: this.formTbai.fechaActivacion
            }
            var response = null
            
            try {
              if (this.newAlta || this.isCompanyCreation) {
                response = await agregarConfiguracionTBAI(data, { idCIFEmpresa: this.formTbai.idCIFEmpresa })
                if (this.isCompanyCreation) this.goNext()
              } else {
                response = await actualizarConfiguracionTBAI(data, { idCIFEmpresa: this.formTbai.idCIFEmpresa })
              }
              if (response && response.blnError === false && response.Respuesta) {
                this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
              } else {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              }
            } catch (error) {
              this.doFeedback()
            } finally {
              this.$store.commit('setIsLoading', false)
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
            this.$store.commit('setIsLoading', false)
            return false
          }
        })
      }, 100)
    },
    showPopover: function (id) {
      return id !== '01' && id !== '02'
    },
    goBack: function () {
      this.$store.dispatch('app/exitMode', 3)
      this.$router.push({ name: 'companies' })
    },
    goNext: function () {
      const modules = this.getModulesClient 
      if (modules.length > 0) {
        setTransitionAllowed(3, true)
        if (modules.includes(12)) {
          this.$router.push({ name: 'companies/pgeconfig', params: { id: this.id } })
        } else if (modules.includes(1)) {
          this.$router.push({ name: 'companies/apsconfig', params: { id: this.id } })
        } else {
          this.goBack()
        }
      } else {
        this.goBack()
      }
    }
  }
}
</script>
<style scoped>

</style>
